/* global Swiper */
const mainBannerSliderElements = document.querySelectorAll('[data-banner-main-slider]');
const tumbnailSliderElements = document.querySelectorAll('[data-banner-tumbnail-slider]');

// *******************************************************************************
// 1.0 - Tumbnail slider
// *******************************************************************************
const tumbnailSliderOptions = {
  threshold: 10,
  touchRatio: 0.33,
  preloadImages: false,
  lazy: {
    loadPrevNext: false,
  },
  slidesPerView: 'auto',
  spaceBetween: 12,
  watchSlidesProgress: true,
  breakpoints: {
    1023: {
      slidesPerView: 3,
      spaceBetween: 12,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 10,
    },
  },
};

tumbnailSliderElements.forEach((el) => new Swiper(el, tumbnailSliderOptions));

// *******************************************************************************
// 2.0 - Main slider
// *******************************************************************************
const mainBannerSliderOptions = {
  threshold: 10,
  touchRatio: 0.33,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  preloadImages: false,
  lazy: {
    loadPrevNext: false,
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  slidesPerView: 1,
  spaceBetween: 0,
  autoHeight: true,
  keyboard: {
    enabled: true,
    onlyInViewport: false,
  },
  thumbs: {
    swiper: false,
  },
};

mainBannerSliderElements.forEach((el, i) => {
  mainBannerSliderOptions.thumbs.swiper = tumbnailSliderElements[i].swiper;

  // eslint-disable-next-line no-unused-vars
  const mainBannerSlider = new Swiper(el, mainBannerSliderOptions);

  // *******************************************************************************
  // Pause sliders and progress bar when you hover on banner card
  // *******************************************************************************
  const bannerCards = document.querySelectorAll('.banner__card');
  const progressBars = document.querySelectorAll('.progress-bar');
  const pauseIcons = document.querySelectorAll('.pause-icon');

  function toggleAutoplay(value) {
    // eslint-disable-next-line no-unused-expressions
    value ? mainBannerSlider.autoplay.stop() : mainBannerSlider.autoplay.start();
    progressBars.forEach((progressBar) => {
      progressBar.classList.toggle('paused', value);
    });
    pauseIcons.forEach((pauseIcon) => {
      pauseIcon.classList.toggle('is-active', value);
    });
  }

  bannerCards.forEach((bannerCard) => {
    bannerCard.addEventListener('mouseenter', () => {
      toggleAutoplay(true);
    });
    bannerCard.addEventListener('mouseleave', () => {
      toggleAutoplay(false);
    });
  });

  tumbnailSliderElements.forEach((thumbnails) => {
    thumbnails.addEventListener('mouseenter', () => {
      toggleAutoplay(true);
    });
  });
});
